export default function Title ({ title }) {
    return (
        <h3 className="lg:text-[38px] text-[22px] font-malaya">{title}</h3>
    )
}